import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
} from '@angular/core';
import {LinkOverlay} from '../link-overlay';
import {LinkUsageService} from '../../../shared/link/link-usage.service';
import {Messages} from '../../../messages.enum';
import {BackendErrorResponse} from '@common/core/types/backend-error-response';
import {HttpErrors} from '@common/core/http/errors/http-errors.enum';
import {LinkOverlayService} from '../link-overlay.service';
import {Toast} from '@common/core/ui/toast.service';
import {CurrentUser} from '@common/auth/current-user';
import {ActivatedRoute} from '@angular/router';
import {DatatableService} from '@common/datatable/datatable.service';
import {Observable, Subscription} from 'rxjs';
import {WorkspacesService} from '@common/workspaces/workspaces.service';
import {ActiveAppSectionService} from '../../active-app-section.service';
import {LINK_OVERLAY_FILTERS} from './link-overlay-filters';

@Component({
    selector: 'link-overlay-index',
    templateUrl: './link-overlay-index.component.html',
    styleUrls: ['./link-overlay-index.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DatatableService],
})
export class LinkOverlayIndexComponent implements OnInit, OnDestroy {
    filters = LINK_OVERLAY_FILTERS;
    overlays$ = this.datatable.data$ as Observable<LinkOverlay[]>;
    private workspaceSub: Subscription;

    constructor(
        public datatable: DatatableService<LinkOverlay>,
        public currentUser: CurrentUser,
        private linkUsage: LinkUsageService,
        private linkOverlays: LinkOverlayService,
        private toast: Toast,
        private route: ActivatedRoute,
        private workspaces: WorkspacesService,
        private activeSection: ActiveAppSectionService
    ) {}

    ngOnInit() {
        this.workspaceSub = this.workspaces.activeId$.subscribe(() => {
            this.setFilters();
        });
        this.datatable.init({
            uri: LinkOverlayService.BASE_URI,
            staticParams: {
                with: ['user'],
                userId: !this.showUserColumn()
                    ? this.currentUser.get('id')
                    : null,
            },
        });
    }

    ngOnDestroy() {
        this.workspaceSub.unsubscribe();
    }

    maybeDeleteSelectedOverlays(overlayIds?: number[]) {
        this.datatable
            .confirmResourceDeletion('link overlays')
            .subscribe(() => {
                this.linkOverlays
                    .delete(overlayIds || this.datatable.selectedRows$.value)
                    .subscribe(
                        () => {
                            this.datatable.reset();
                            this.linkUsage.reload();
                            this.toast.open(
                                Messages.LINK_OVERLAY_DELETE_SUCCESS
                            );
                        },
                        (errResponse: BackendErrorResponse) => {
                            this.toast.open(
                                errResponse.message || HttpErrors.Default
                            );
                        }
                    );
            });
    }

    showUserColumn(): boolean {
        // show in admin and if active workspace is not personal
        return this.activeSection.admin || !!this.workspaces.activeId$.value;
    }

    private setFilters() {
        this.filters = LINK_OVERLAY_FILTERS.filter(
            f => f.key !== 'user_id' || this.showUserColumn()
        );
    }
}
